import { useMutation, useQueryClient } from 'react-query';

import { updateObject as update } from 'api/clients/updateObject';

const useUpdateObject = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: updateObject,
    isLoading,
  } = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries('objects');
    },
  });

  return {
    isSuccess,
    updateObject,
    isLoading,
  };
};

export default useUpdateObject;
